var _is_ready_app_webview = false;

function is_app() {
    var user_agent = navigator.userAgent.toLowerCase();
    return (user_agent.includes("com.cconmausa.app:"));
}

function get_app_version() {
    if (is_app())
    {
        var user_agent = navigator.userAgent.toLowerCase();
        var app_version = user_agent.split("com.cconmausa.app:")[1];
        app_version = app_version.split(".");
        app_version = (app_version[0]) * 10000 + (app_version[1] * 100) + (app_version[2] * 1);
        console.log("app_version:" + app_version);
        return app_version;
    }
    return 0;
}

/**
 * 네이티브 앱에서 종료 직전에 호출하는 메서드: 종료 여부를 확인하는 UI 컨펌 팝업 표시 여부
 * @return {boolean} true를 반환하면 종료 확인 UI 컨펌 표시 안함
 */
function close_popup() {
    var result = false;


    if (typeof lib_mobile_menus != 'undefined')
    {
        result = result || lib_mobile_menus.back_by_device();
    }
    if (typeof close_address_popup == 'function')
    {
        result = result || close_address_popup();
    }
    if (typeof close_codepoint_pay_popup == 'function')
    {
        result = result || close_codepoint_pay_popup();
    }
    /*



        if (typeof close_k2k_address_popup == 'function')
        {
            result = result || close_k2k_address_popup();
        }
    */
    if (window.CUSPayModal !== undefined)
    {
        if (typeof window.CUSPayModal.close_modal_all == 'function')
        {
            result = result || window.CUSPayModal.close_modal_all();
        }


        if (typeof window.CUSPayModal.close_modal_k2k_address == 'function')
        {
            result = result || window.CUSPayModal.close_modal_k2k_address();
        }

        if (typeof window.CUSPayModal.close_modal_k2k_address_search == 'function')
        {
            result = result || window.CUSPayModal.close_modal_k2k_address_search();
        }
    }



    if (typeof closeBootstrapModal == 'function')
    {
        result = result || closeBootstrapModal();
    }

    if (typeof closePhotoViewModal == 'function')
    {
        result = result || closePhotoViewModal();
    }


// 모달이 열려있으면 history back(종료확인 UI 컨펌 표시안함)
    if (window.backKeyTrapper.hasName('modal'))
    {
        window.history.back();
        result = true;
    }

    return result;
}

function hide_appbar() {
    if (_is_ready_app_webview && get_app_version() >= 10102)
        window.flutter_inappwebview.callHandler('hide_appbar');
}
function show_appbar() {
    if (_is_ready_app_webview && get_app_version() >= 10102)
        window.flutter_inappwebview.callHandler('show_appbar');
}




//flutter webview 초기화체크
if (is_app())
{

    window.addEventListener("flutterInAppWebViewPlatformReady", function (event) {
        _is_ready_app_webview = true;
    });

    $(document).ready(function () {
        var $popup_layer = $(".cl_popup_layer");

        if ($popup_layer.length > 0)
        {

            $popup_layer.on("show", function () {
                hide_appbar();
            });
            $popup_layer.on("hide", function () {
                show_appbar();
            });

            $.each(['show', 'hide'], function (i, ev) {
                var el = $.fn[ev];
                $.fn[ev] = function () {
                    this.trigger(ev);
                    return el.apply(this, arguments);
                };
            });



        }

        //앱심사대응
        /*/
       if(is_ios() && get_app_version() >= 10303){
            var chIntervalHandler = setInterval(function () {
                $("#ch-plugin").hide();
            }, 300);
        }
        /**/
    });
}



$(document).ready(function(){
    //앱 접속인 경우 모바일화면 모드 유지하기위한 처리
    // - 모바일화면 모드에 대한 정의가 css수준에서 width로만 판별하기 때문에 아이패드pro에 설치된 꽃마앱인 경우, 경우에따라 테스크탑화면으로 표시되고 있다.
    if(is_app())//app접속인 경우
    {
        $(".mobile-fixed-bottom-menu-container").show();
        $(".top-mobile-container").show();
        //$("#search-vue-container .mobile-view").show();
        $(".top-pc").hide();
        $(".footer-container").hide();

        var $go_to_top_btn = $(".go-to-top-btn");
        $go_to_top_btn.css("bottom","65px");
        $go_to_top_btn.css("left","10px");

        //ipad pro 가로모드인 경우
        if($(window).width() >= 1024)
        {
            $(".top-mobile .top-nav-container").css("display","block");
        }

    }

    //하단 메뉴가 표시되는 경우(모바일모드)에 한해 채널톡버튼을 하단메뉴위로 조정한다.
    if($(".mobile-fixed-bottom-menu-container").is(":visible")){

        var ch_plugin_interval_count = 0;
        var ch_plugin_interval = setInterval(function () {

            var $ch_plugin = $("#ch-plugin");
            if($ch_plugin.length > 0)
            {
                try{
                    var shadowroot_parent = document.getElementById("ch-plugin-entry").getElementsByTagName( 'div' )[0];
                    var ch_plugin_launcher = shadowroot_parent.shadowRoot.querySelector("#ch-plugin-launcher");
                    if(typeof ch_plugin_launcher != "undefined"){
                        var $launcher = $(ch_plugin_launcher).parent();
                        $launcher.css("bottom","70px");
                        ch_plugin_interval_count++;
                        if(ch_plugin_interval_count >= 3){
                            clearInterval(ch_plugin_interval);
                        }

                    }
                }catch (e){
                    console.log(e);
                    //clearInterval(ch_plugin_interval);
                }
            }
        },300);
    }


    /*///친구초대버튼(app:automizely)의 위치를 채널톡버튼 위로 조정한다.(패드,데스크탑에만)
    var automizely_interval_count = 0;
    var automizely_interval = setInterval(function () {
        var automizely_wrapper = null;
        var automizely_shadowroot = null;
        var $rk_root = $("#rk-root");
        var $next = $rk_root.next();
        for(i=0;i<=5;i++){
            automizely_wrapper = $next[0];
            if(is_empty(automizely_wrapper)){
                continue;
            }
            automizely_shadowroot = $next[0].shadowRoot;
            if(!is_empty(automizely_shadowroot)){
                //_console_log(i + " automizely_shadowroot 찾음");
                break;
            }else{
                $next = $next.next();
            }
        }
        //var automizely_wrapper = $("#rk-root").next()[0].;

        if(!is_empty(automizely_shadowroot)){

            var a_speed_dial = automizely_shadowroot.querySelector(".a-speed-dial");
            var $a_popup = $(automizely_shadowroot.querySelector(".a-popup"));

            $a_popup.css("top","0px");
            $(automizely_wrapper).css("z-index",9999999);


            if(!is_phone_width()){
                $(a_speed_dial).css("position","fixed");
                $(a_speed_dial).css("top","auto");
                $(a_speed_dial).css("right","30px");
                $(a_speed_dial).css("bottom","100px");
                $(a_speed_dial).css("transform","unset");
                if($(".mobile-fixed-bottom-menu-container").is(":visible")){
                    $(a_speed_dial).css("bottom","140px");
                }
            }

            automizely_interval_count++;
            if(automizely_interval_count >= 3){
                clearInterval(automizely_interval);
            }
        }

    }, 500);
    /**/
});

